import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  width: 100%;
  background: rgba(226,232,236,.30);
  justify-content: flex-start;
  align-items: flex-start;
`
const Table = styled.table`
  width: 100%;
  height: 100%;
  border-spacing:0;
  border-collapse: collapse;
`
const TableRow = styled.tr`
  display: flex;
  justify-content: center;
  width: 100%;
`
const TableHeaderLarge = styled.th`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  padding: 4px;
  font-size: 12px;
`
const TableCellLarge = styled.td`
  display: flex;
  flex:3;
  justify-content: center;
  align-items: center;
  padding: 4px;
  font-size: 12px;
`
const InfoCell = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  font-size: 12px;
  height: 26px;
`
const InfoRow = styled.div`
  display: flex;
  justify-content: center;
  margin-left: 4px;
  font-size: 14px;
`

const Subcomponent = props => (
  <Container>
    <Table>
      <thead>
        <TableRow>
          <TableHeaderLarge>
            Fechas de Inicio y Fin
          </TableHeaderLarge>
          <TableHeaderLarge>
            Monto Detallado
          </TableHeaderLarge>
          <TableHeaderLarge>
            Comprobante
          </TableHeaderLarge>
        </TableRow>
      </thead>
      <tbody>
        <TableRow>
          <TableCellLarge>
            <InfoCell>
              <InfoRow>{props.row.original.start_date}</InfoRow>
              <InfoRow>{props.row.original.end_date}</InfoRow>
            </InfoCell>
          </TableCellLarge>
          <TableCellLarge>
            {props.row.original.amount_tuition_fee}
          </TableCellLarge>
          <TableCellLarge >
            <img
              alt="Ver comprobante"
              style={{cursor: 'pointer'}}
              onClick={() => window.open(props.row.original.receipt_full_path)}
              src="/assets/visibility.svg"/>
          </TableCellLarge>
        </TableRow>
      </tbody>
    </Table>
  </Container>
)

export default Subcomponent



// WEBPACK FOOTER //
// ./src/Containers/ServiceOccasional/Subcomponent.jsx